module.exports = __webpack_public_path__ + "img/player3.49828a2f.png";